angular.module('rentalListingModule').component('rentalListingLogin', {
	templateUrl: 'rentalListingLogin/rentalListingLogin.html',
	bindings: {
		form: '<',
		user: '<',
		listing: '<',
		isMobile: '<',
		fbError: '<',
		errorMessages: '<',
		termsOfUseUrl: '<',
		privacyPolicyUrl: '<',
		forgotLinkUrl: '<',
		onDisplayForm: '&',
		onFbLogin: '&',
		onFieldChange:'&'
	},
	controller: ['$http', function($http) {
		this.register = function() {
			this.onDisplayForm({form: 'registration'});
		};

		this.fbLogin = function() {
			this.onFbLogin();
		};

		this.fieldChange = function(key) {
			this.onFieldChange({key: key});
		};
	}]
});
